import type { InterstateOnChangeEvent } from '@interstate/components/InterstateEvents/Types/InterstateInputEventTypes';
import type { DomEventType } from '@interstate/components/InterstateEvents';

export const isBlurEvent = (e: InterstateOnChangeEvent<any>) => {
    return e.domEvent && (e.domEvent as Exclude<DomEventType, Record<string, never>>).type === 'blur';
};
